// @flow
import { useLoadPlans } from "queries/payments/useLoadPlans";
import * as React from "react";
import Flex from "ui/atoms/Flex";
import FlexBox from "ui/atoms/FlexBox";
import Modal from "ui/atoms/Modal";
import Space from "ui/atoms/Space";
import Text from "ui/atoms/Text";

type Props = {
  planId: string,
  onClose: () => void,
};

function CurrentPlanDetails({ planId, onClose }: Props): React.Node {
  const { data: plansResult, isLoading: isPlansLoading } = useLoadPlans();
  const currentPlan = plansResult?.results?.find((plan) => plan.id === planId);

  return (
    <Modal
      closeButton
      show
      loading={isPlansLoading}
      onClose={onClose}
      onHide={onClose}
      subtitle="Here's how your plan breaks down this month"
      title={currentPlan?.product?.name}
    >
      <FlexBox>
        <Space size="large">
          <Flex $flexDirection="col">
            <Flex align="center" className="w-full" justify="between">
              <Text>2 user</Text>
              <Text className="w-15 text-left">$69.99</Text>
            </Flex>
            <Text $light $small>
              $49 + $20 /additional user
            </Text>
          </Flex>

          <Flex $flexDirection="col">
            <Flex align="center" className="w-full" justify="between">
              <Text>Additional Submissions</Text>
              <Text className="w-15 text-left">$20</Text>
            </Flex>
            <Text $light $small>
              500 included
            </Text>
          </Flex>

          <Flex $flexDirection="col">
            <Flex align="center" className="w-full" justify="between">
              <Text>SMS Messages</Text>
              <Text className="w-15 text-left">$0</Text>
            </Flex>
            <Text $light $small>
              250 out of 300 messages (.02 after limit)
            </Text>
          </Flex>

          <Flex $flexDirection="col">
            <Flex align="center" className="w-full" justify="between">
              <Text>Form Creation Service</Text>
              <Text className="w-15 text-left">$0</Text>
            </Flex>
            <Text $light $small>
              2 pages
            </Text>
          </Flex>
        </Space>
      </FlexBox>
    </Modal>
  );
}

export default CurrentPlanDetails;
